import * as React from "react";
import { cloneDeep } from "lodash";
import { toastr } from "react-redux-toastr";
import VisualSearchService from "src/share/services/visualSearch";
import { initialVisualSearchState, By, VisualSearchActions } from "src/share/types/visualSearch";
import { validateImage } from "src/share/utils/fileHandler";
import visualSearchReducer from "../state/reducer";

export const usePimEyes = () => {
  const [state, dispatch] = React.useReducer(visualSearchReducer, cloneDeep(initialVisualSearchState));
  async function fetchImages(image, by: By) {
    if (by === By.Base64 && !validateImage(image)) {
      dispatch({ type: VisualSearchActions.error, payload: "Image size exceeded." });
      return toastr.error("Image size exceeded", "The uploaded image is too big.");
    }
    try {
      dispatch({ type: VisualSearchActions.setFaceLoading });
      const faces = await VisualSearchService.pimeyesUpload(image, by);
      loadAndSendFace(faces);
    } catch (err) {
      dispatch({ type: VisualSearchActions.error, payload: "The given image couldn't be processed." });
      toastr.error("Error", "The given image couldn't be processed.");
    }
  }
  async function loadAndSendFace(faces) {
    if (faces.length === 0) {
      const error = "No face could be detected.";
      dispatch({ type: VisualSearchActions.error, payload: error });
      toastr.error("Error", error);
      return;
    } else if (faces.length > 1) {
      dispatch({ type: VisualSearchActions.setFaces, payload: faces });
      return;
    }
    sendImage(faces[0].id);
  }
  async function sendImage(face) {
    dispatch({ type: VisualSearchActions.setLoading });
    const images = await VisualSearchService.pimeyesSearch([face]);
    dispatch({ type: VisualSearchActions.setImages, payload: images });
  }
  return {
    state,
    actions: { dispatch, fetchImages, sendImage }
  };
};



// WEBPACK FOOTER //
// ./src/modules/AdHocTools/VisualSearch/hooks/usePimEyes.ts